import moment from "moment-jalaali";

export const getCurrentWeek = () => {
  const today = moment();
  const startOfWeek = today.clone().startOf("week").toDate();
  const endOfWeek = today.clone().endOf("week").toDate();
  return [startOfWeek, endOfWeek];
};
